import { render, staticRenderFns } from "./DiscountCards.vue?vue&type=template&id=40b52c0e"
import script from "./DiscountCards.vue?vue&type=script&lang=js"
export * from "./DiscountCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports